import { LoadingSection } from '@/components/shared/LoadingSection';
import { Skeleton } from '@/components/ui/skeleton';

/**
 * One placeholder per field the loaded section renders, in the order and the two-column grid
 * `PolicyholderSection` uses. The widths vary so the block reads as a form rather than as a barcode.
 */
const FIELD_WIDTHS = [
  'w-28',
  'w-44',
  'w-20',
  'w-32',
  'w-24',
  'w-16',
  'w-24',
  'w-32',
  'w-10',
  'w-16',
] as const;

export function PolicyholderSkeleton(): React.JSX.Element {
  return (
    <LoadingSection title="Policyholder Information" message="Loading policy information…">
      <div className="grid gap-x-10 gap-y-3 sm:grid-cols-2">
        {FIELD_WIDTHS.map((width, index) => (
          <div key={index} className="flex min-h-5 items-center gap-4">
            <span className="w-36 flex-none">
              <Skeleton className="h-4 w-24" />
            </span>
            <Skeleton className={`h-4 ${width}`} />
          </div>
        ))}
      </div>
    </LoadingSection>
  );
}
